<template>
  <v-container text-xs-center>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-toolbar color="secondary">
            <v-toolbar-title class="text-xs-center">Attendance book</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>chat</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list subheader>
            <template v-for="(edge, index) in this.clubInfoNew">
              <v-subheader :key="index">
                <v-select
                  v-model="groupname"
                  :rules="groupRules"
                  required
                  :hint="`${groupname}`"
                  label="Select Group Name"
                  :items="edge.node.team.edges"
                  item-value="node.teamId"
                  item-text="node.teamName"
                >
                  {{ groupname }}
                </v-select>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Select Date"
                      :rules="groupDate"
                      prepend-icon="event"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-subheader>

              <template v-for="teams in edge.node.team.edges">
                <v-list-item
                  avatar
                  lazy-validation
                  v-for="(athlete, i) in teams.node.athlete.edges.filter(
                    (athlete) => athlete.node.teamId == groupname && athlete.node.status == 'active'
                  )"
                  v-bind:key="athlete.node.athleteId"
                  @click="
                    handleAddAttendance(
                      athlete.node.athleteId,
                      !teams.node.athlete.edges[i].value, // Set missed based on switch
                      date,
                      comments
                    )
                  "
                >
                  <v-list-item-content>
                    <v-list-item-avatar>
                      <v-avatar size="40">
                        <img
                          src="https://randomuser.me/api/portraits/lego/6.jpg"
                          alt="Avatar"
                        />
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-title
                      v-html="athlete.node.firstName + ' ' + athlete.node.lastName"
                    ></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-switch
                      color="secondary"
                      v-model="teams.node.athlete.edges[i].value"
                    ></v-switch>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      groupname: "",
      comments: "",
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      groupRules: [(groupname) => !!groupname || "Group is Required"],
      groupDate: [(date) => !!date || "Date is Required"],
    };
  },
  computed: {
    ...mapGetters(["loading", "clubInfo"]),
    clubInfoNew() {
      return this.clubInfo.edges.filter(
        (item) => item.node.clubId == this.$route.params.club
      );
    },
  },
  methods: {
    handleAddAttendance(athleteId, status, date) {
      // status is inverted because ON means attended (missed: false)
      this.$store.dispatch("addAttendance", {
        attendanceId: 0,
        athleteId: athleteId,
        workoutId: 1,
        effectiveDate: date,
        missed: status, // Status is passed as true when switch is OFF (missed)
        comments: date,
        updateSource: "VueJS tst",
      });
    },
  },
  mounted() {
    console.log(this.clubInfoNew);
    this.clubInfoNew.forEach((edge) => {
      edge.node.team.edges.forEach((team) => {
        team.node.athlete.edges.forEach((athlete) => {
          if (athlete.value === undefined) {
            athlete.value = true; // Default switch to ON, indicating attendance
          }
        });
      });
    });
  },
};
</script>
